import { Component } from '@angular/core';
import { Icon } from '@local/ui-infra';

@Component({
  selector: 'relevant-people-empty-state',
  templateUrl: './relevant-people-empty-state.component.html',
  styleUrls: ['./relevant-people-empty-state.component.scss'],
})
export class RelevantPeopleStateComponent {
  readonly emptyStateIcon: Icon = {
    lightUrl: 'assets/empty-state/relevant-people/relevant-people-empty-state-light.svg',
    darkUrl: 'assets/empty-state/relevant-people/relevant-people-empty-state-dark.svg',
  };
}
